export default {
  generateReportLoading: false,
}
